var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"camera-page-header",class:{
    isPC: _vm.$store.getters['camera/isPC'],
    isI18nJa: _vm.$i18n.locale == 'ja',
    isI18nVi: _vm.$i18n.locale == 'vi',
    isI18nEn: _vm.$i18n.locale == 'en',
    isAutodetect: _vm.$store.state.camera.isDetectStart
  }},[_c('div',{staticClass:"header-title",style:({ height: ((_vm.$store.state.camera.headerHeight - 1) + "px") })},[_vm._t("default")],2),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-border"},[_c('div',{staticClass:"header-border-line"})])}]

export { render, staticRenderFns }